'use strict';

import React, { Component } from 'react'

import Link  from '@Pure/Link'

import config from '@Config/Configuration/national_brand'

const { moment } = window;

export default class NationalBrandRow extends Component
{
	render ()
	{
		const { data, blank=true, fields, ...props } = this.props;

		moment.locale('fr');

		const blank_props = blank === true
		? { target: '_blank', rel: 'noopener noreferrer' }
		: { };

		const link =
		(
			<Link className="u-link-only" { ...blank_props }
				href={ config.row_link_base + data.id }>
				<span className="u-readers-only">
					Voir l'enseigne
				</span>
			</Link>
		);

		let output =
		(
			<div className="c-dashboard__row">

				<div className="c-dashboard__cell NationalBrand-name">

					<div className="c-dashboard__long-text">
						{ data.name }
					</div>

					{ link }

				</div>

			</div>
		);

		return output;
	}
}